<template>
  <span class="powered-by">
    <img width="880" height="230" :src="imgUrl" />
  </span>
</template>

<style lang="scss">
@import "../assets/styles/powered-by.scss";
@import "../assets/styles/kiosk-landscape-30inch/powered-by.scss";
</style>
<script lang="ts">
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  setup() {
    const store = useStore(),
      config = computed(() => store.state.config.config),
      imgUrl = computed(
        () =>
          `${config.value.publicPath}branding/${
            process.env.NODE_ENV === "development"
              ? `${process.env.VUE_APP_BRANDING_DIRECTORY}/`
              : ""
          }powered-by-light.svg`
      );

    return {
      imgUrl
    };
  }
};
</script>
